import * as actions from './actions';

const initialState = {
  // Anonymous per-reading purchase
  pendingReadingId: null,
  pendingLoading: false,
  checkoutLoading: false,
  checkoutError: null,
  purchaseVerified: false,
  paidReadingId: null,
  paidReading: null,
  paidEmail: null,
};

export default function quiromanciaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_PENDING_REQUEST:
      return { ...state, pendingLoading: true, pendingReadingId: null };
    case actions.CREATE_PENDING_SUCCESS:
      return { ...state, pendingLoading: false, pendingReadingId: action.payload.readingId };
    case actions.CREATE_PENDING_FAILURE:
      return { ...state, pendingLoading: false, checkoutError: action.payload };

    case actions.CHECKOUT_REQUEST:
    case actions.PAYPAL_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null };
    case actions.CHECKOUT_SUCCESS:
    case actions.PAYPAL_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.CHECKOUT_FAILURE:
    case actions.PAYPAL_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload };

    case actions.VERIFY_REQUEST:
    case actions.VERIFY_PAYPAL_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null };
    case actions.VERIFY_SUCCESS:
    case actions.VERIFY_PAYPAL_SUCCESS:
      return {
        ...state,
        checkoutLoading: false,
        purchaseVerified: true,
        paidReadingId: action.payload.reading_id,
        paidReading: action.payload,
        paidEmail: action.payload.email,
      };
    case actions.VERIFY_FAILURE:
    case actions.VERIFY_PAYPAL_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload };

    default:
      return state;
  }
}
